/**
 * Customer Communications API Service
 *
 * Handles API calls for the customer comms dashboard.
 * Read-only — fetches paginated confirmation request data
 * enriched with customer, vehicle, and timing details.
 */

import axiosInstance from './axiosInstance';

/**
 * Get paginated customer communications, optionally filtered by date range.
 * @param {{ page?: number, size?: number, dateFrom?: string, dateTo?: string }} options
 * @returns {Promise<{ content: Array, totalPages: number, totalElements: number, number: number, size: number }>}
 */
export const getCustomerCommsApi = async ({ page = 0, size = 30, dateFrom, dateTo } = {}) => {
    const params = { page, size, sort: 'updatedAt,desc' };
    if (dateFrom) params.dateFrom = dateFrom;
    if (dateTo) params.dateTo = dateTo;

    const response = await axiosInstance.get('/customer-comms', { params });
    return response.data;
};

/**
 * Get status counts for the given date range (or all-time if omitted).
 * Returns { SENT: n, APPROVED: n, DECLINED: n, EXPIRED: n, total: n }
 * @param {{ dateFrom?: string, dateTo?: string }} options
 */
export const getCommsSummaryApi = async ({ dateFrom, dateTo } = {}) => {
    const params = {};
    if (dateFrom) params.dateFrom = dateFrom;
    if (dateTo) params.dateTo = dateTo;

    const response = await axiosInstance.get('/customer-comms/summary', { params });
    return response.data;
};

const customerCommsApi = {
    getCustomerCommsApi,
    getCommsSummaryApi,
};

export default customerCommsApi;